import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import productReducer from "./reducers/productReducer";
import userReducer from "./reducers/userReducer";
import blogReducer from "./reducers/blogReducer";
import categoryReducer from "./reducers/categoryReducer";
import notificationReducer from "./reducers/notificationReducer";
import wishlistReducer from "./reducers/wishlistReducer";
import cartReducer from "./reducers/cartReducer";
import { report } from "process";
import ReportedProductsReducer from "./reducers/reportedProductsReducer";

const rootReducer = combineReducers({
  products: productReducer,
  users: userReducer,
  blogs: blogReducer,
  categories: categoryReducer,
  notifications: notificationReducer,
  wishlists: wishlistReducer,
  carts: cartReducer,
  reportedProducts: ReportedProductsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
